import React, { useEffect, useState, useMemo } from 'react'
import debounce from 'lodash.debounce';
import { Button, Form } from 'react-bootstrap';
import Table from '../../components/table/Table';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { DeleteMultipleOtherApp, OtherAppAction } from '../../redux/Action/OtherAppAction';
import { DELETE_MULTIPLE_OTHER_APPS } from '../../redux/type';
import { AppStatus } from '../../helper/Constant';
import Loading from '../../layout/Loading';
import DeleteLogo from './../../assets/img/Delete.png'
import DeleteModal from '../../components/modals/DeleteModal';

const Others = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [otherApps, setOtherApps] = useState([])
    const [pagination, setPagination] = useState({
        page: 0,
        limit: 50,
    })
    const [totalCount, setTotalCount] = useState(0)
    const [filterStatus, setFilterStatus] = useState()
    const [search, setSearch] = useState()
    const [selectedRows, setSelectedRows] = useState([])
    const [deleteModal, setDeleteModal] = useState(false)

    const otherAppsData = useSelector((state) => state.otherapps.app)
    const deleteMultiple = useSelector((state) => state.otherapps.deletemultiapp)
    const loading = useSelector((state) => state.otherapps.loading)

    useEffect(() => {
        dispatch(OtherAppAction(pagination, search, filterStatus))
    }, [search, pagination, filterStatus])

    useEffect(() => {
        if (otherAppsData) {
            setOtherApps(otherAppsData.data)
            setTotalCount(otherAppsData.count)
        }
    }, [otherAppsData])

    useEffect(() => {
        if (deleteMultiple && deleteMultiple.status === 200) {
            dispatch({
                type: DELETE_MULTIPLE_OTHER_APPS,
                payload: ""
            })
            toast.success(deleteMultiple.message)
            setSelectedRows([])
            dispatch(OtherAppAction(pagination, search, filterStatus))
        }
    }, [deleteMultiple])

    const columns = [
        {
            id: 'logo',
            numeric: false,
            disablePadding: true,
            label: 'Logo',
            selector: 'logo'
        },
        {
            id: 'name',
            numeric: false,
            disablePadding: true,
            label: 'App Name',
            selector: 'name'
        },
        // {
        //     id: 'appLink',
        //     numeric: true,
        //     disablePadding: false,
        //     label: 'App Link',
        //     selector: 'appLink'
        // },
        {
            id: 'packageName',
            numeric: true,
            disablePadding: false,
            label: 'Package Name',
            selector: 'packageName'
        },
        {
            id: 'consoleLink',
            numeric: true,
            disablePadding: false,
            label: 'Console Link',
            selector: 'consoleLink'
        },
        {
            id: 'status',
            numeric: true,
            disablePadding: false,
            label: 'Status',
            selector: 'status'
        },
        {
            id: 'version',
            numeric: true,
            disablePadding: false,
            label: 'Version',
            selector: 'version'
        },
        {
            id: 'notes',
            numeric: true,
            disablePadding: false,
            label: 'Notes',
            selector: 'notes'
        },
        {
            id: 'action',
            numeric: true,
            disablePadding: false,
            label: 'Action',
            selector: 'action',
            action_type: ['VIEW', 'EDIT'],
        },
    ];

    const getAction = (obj) => {
        if (obj.type == "VIEW") {
            navigate(`/view-other/${obj.id}`)

        }
        if (obj.type == "EDIT") {
            navigate(`/edit-other/${obj.id}`)
        }
    }

    const handleFilterStatus = (e) => {
        setPagination({ ...pagination, page: 0 })
        setFilterStatus(e.target.value)
    }

    const handleChange = useMemo(
        () =>
            debounce((e) => setSearch(e.target.value), 1000)
        , [search]);

    useEffect(() => {
        return () => handleChange.cancel();
    }, []);

    const handleMultipleDelete = () => {
        setDeleteModal(true)
    }

    const onConfirmDelete = () => {
        dispatch(DeleteMultipleOtherApp(selectedRows))
        setDeleteModal(false)
    }

    return (
        <>
            <div className='android-main'>
                <div className='android-main-card p-0'>
                    <div className='card__header'>
                        <h1 className='title'>Others</h1>
                        <div className='card_filter'>
                            {selectedRows.length > 0 && (
                                <div >
                                    <img className='multi_delete_icon' onClick={handleMultipleDelete} src={DeleteLogo} alt='' />
                                </div>
                            )}
                            <div>
                                <Form.Select className='form-input' name='Status' value={filterStatus} onChange={handleFilterStatus} aria-label="Default select example">
                                    <option value=''>All</option>
                                    <option value={AppStatus.Live}>{AppStatus.Live}</option>
                                    <option value={AppStatus.Removed}>{AppStatus.Removed}</option>
                                </Form.Select>
                            </div>
                            <div className='card_filter_search'>
                                <input type='search' placeholder=' Search...' defaultValue={search} onChange={handleChange}></input>
                            </div>
                            <Button className='header_button' onClick={() => navigate('/add-other')}>Add New</Button>
                        </div>
                    </div>
                    {(loading && !otherApps.length) ? <Loading /> : (
                        <Table
                            headCells={columns}
                            rows={otherApps}
                            getAction={getAction}
                            pagination={pagination}
                            setPagination={setPagination}
                            count={totalCount}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                        />
                    )}
                </div>
            </div>
            {deleteModal && <DeleteModal show={deleteModal} onHide={() => setDeleteModal(false)} onConfirmDelete={onConfirmDelete} />}
        </>
    )
}

export default Others